import { ShowWrapper } from "@/layouts/ShowWrapper";
import { useShow } from "@refinedev/core";
import { EksSummaryPanel } from "./EksSummary";
import { EksNodeGroupPanel } from "./EksNodeGroup";
import { EventsPanel } from "@/components/instance/panels/Events";
export const ShowEks = () => {
  const {
    query: { data, isLoading },
  } = useShow();
  const tabs = [
    { key: 'summary', label: 'Summary', children: (<EksSummaryPanel data={data} />) },
    { key: 'nodeGroups', label: 'Node Groups', children: (<EksNodeGroupPanel data={data}/>) },
    { key: "events", label: "Events", children: (<EventsPanel type="eks"/> )}
  ];
  return (
    !isLoading && <ShowWrapper details={tabs} />
  );
};